import { type PropsWithChildren, type ReactNode } from 'react';

import styles from './UndergroundMapLayout.css';

export function UndergroundMapLayout({ children }: PropsWithChildren): ReactNode {
  return (
    <div className={styles['container']}>
      <div className={styles['inner']}>{children}</div>
    </div>
  );
}
